<template>
     <div class="box">
        <div class="contaner-title"><span>项目管理</span> <span>/ 竞标项目</span> <span>/ 项目沟通</span></div>
        <div class="hr"></div>
        <div class="box-step">
            <div class="line-dot">
                <span class="dot" :class="{'active-dot':finshFlag}"></span>
                <span class="line" :class="{'active-dot':finshFlag}"></span>
                <span class="dot" :class="{'active-dot':finshFlag}"></span>
                <!-- <span class="line"></span> -->
                <div  class="process-num">
                        <Progress   stroke-color='#00B200' :percent="ProjectDetail.percent" :stroke-width="2"   hide-info  />
                        <span :style="{'left':ProjectDetail.percent+'%'}">{{ProjectDetail.percent}}%</span>
                </div>
             
                <span class="dot"></span>
            </div>
            <div>
                <Row class="line-text">
                    <Col span="2">发包方发布项目
                    <p>{{ProjectDetail.AddTime}}</p></Col>
                      <Col span="20">选定承接人，项目进入开发
                    <p>{{ProjectDetail.ProjectMember.DevelopTime}}</p></Col>
                      <Col span="2">计划项目完工
                    <p>{{ProjectDetail.EndTime}}</p></Col>
                </Row>
            </div>
            
        </div>
        <div class="box-contaner">
            <div class="box-top" >
            <Row class="box-top-title">
                <Col span="20">
                    <p class="title">{{ProjectDetail.Name}}  
                        <Button v-if="ProjectDetail.Status == 2" type="error" size="small" ghost>
                            <span>剩余{{ProjectDetail.DayNum}}天</span>
                        </Button>
                        <Button v-if="ProjectDetail.Status == 3" type="error" size="small" ghost>
                            <span>已完结</span>
                        </Button>
                        <Button v-if="ProjectDetail.Status == 4" type="error" size="small" ghost>
                            <span>已超时</span>
                        </Button>
                        <Button v-if="ProjectDetail.Status == 6" type="error" size="small" ghost>
                            <span>已终止(部分打款)</span>
                        </Button>
                        <Button v-if="ProjectDetail.Status == 7" type="error" size="small" ghost>
                            <span>已终止</span>
                        </Button>
                    </p>
                </Col>
                <Col v-if="UserType == 2 || UserType == 3" span="4">
                    <span>
                        <Button v-if="ProjectDetail.Status == 2" @click="showCloseWindow = true" type="error" style="margin-right:10px;">关闭项目</Button>
                        <Button v-if="ProjectDetail.Status == 4" @click="handleDelay" type="error">项目延期</Button>
                        <Button v-if="ProjectDetail.Status == 2" @click="showCompleteWindow = true" type="success">项目完结</Button>
                    </span>
                </Col>
            </Row>
            <Row class="box-top-center" >
                <Col span="4"><span>&nbsp;</span></Col>
                    <Col span="4"  style="text-align:center;">项目报酬 <p style="font-size:20px;color:#00AAE3;">{{ProjectDetail.Amount}}</p></Col>
                    <Col span="2" style="text-align:center;">=</Col>
                    <Col span="4" style="text-align:center;">已结款项 <p style="font-size:20px;color:#00B22C;">{{ProjectDetail.AmountSettled}}</p></Col>
                    <Col span="2">+</Col>
                    <Col span="4"  style="text-align:center;">剩余款项 <p style="font-size:20px;">{{ProjectDetail.Amount - ProjectDetail.AmountSettled}}</p></Col>
                    <!-- <Col span="4"><Button type="primary" size="small">修改竞标信息</Button></Col> -->
                </Row>
                <Row class="box-top-bottom">
                    <Col span="2"><span>&nbsp;</span></Col>
                    <Col v-if="UserType == 1" span="3"><img src="../../assets/name_icon.png" alt=""> <span>{{ProjectDetail.ContactName}}</span></Col>
                    <Col v-if="UserType == 2 || UserType == 3" span="3"><img src="../../assets/name_icon.png" alt=""> <span>{{ProjectDetail.ProjectMember.Apply_ContactName}}</span></Col>
                    <Col v-if="UserType == 1" span="3"><img src="../../assets/mobile_icon.png" alt=""> <span>{{ProjectDetail.Tel}}</span></Col>
                    <Col v-if="UserType == 2 || UserType == 3" span="3"><img src="../../assets/mobile_icon.png" alt=""> <span>{{ProjectDetail.ProjectMember.Apply_Tel}}</span></Col>
                    <Col v-if="UserType == 1" span="3"><img src="../../assets/QQ_icon.png" alt=""><span>{{ProjectDetail.QQ}}</span></Col>
                    <Col v-if="UserType == 1" span="3"><img src="../../assets/email_icon.png" alt=""><span>{{ProjectDetail.Email}}</span></Col>
                    <Col v-if="UserType == 2 || UserType == 3" span="11"><img src="../../assets/email_icon.png" alt=""> <span>{{ProjectDetail.ProjectMember.Apply_Email}}</span></Col>
                </Row>
            </div>
            <div class="btn-tips">
                <p @click="openProjectDetail">查看全部信息<Icon type="ios-arrow-down" /></p>
            </div>
            <div class="box-center" v-if="showProjectDetail">
                <h2><img src="../../assets/user_icon.png"/>项目需求</h2>
                <p>{{ProjectDetail.Content}}</p>
            </div>
            <div class="box-center" v-if="showProjectDetail">
                <h2><img src="../../assets/link_icon.png"/>附件</h2>
                <ul>
                    <li v-for="(item,index) in ProjectDetail.Attach">
                       <a :href="fileUrl+item.url"><Icon type="md-attach" /><span>{{item.name}}</span></a>
                    </li>
                </ul>
            </div>
            <div class="box-center" v-if="showProjectDetail">
                <h2 v-if="UserType == 2 || UserType == 3"><img src="../../assets/my_icon.png"/>{{ProjectDetail.ProjectMember.Apply_ContactName}}的记录</h2>
                <h2 v-if="UserType == 1"><img src="../../assets/my_icon.png"/>我的记录</h2>
                <Table :columns="columnsBiddingRecordList" :data="ProjectDetail.ProjectMember.RecordList"></Table>
            </div>
        </div>
        <div class="box-import">
            <div class="box-import-left"> 
                <p><img src="../../assets/jie_icon.png" alt="" >环节确认</p>
                <span v-if="UserType == 1"><Icon type="ios-information-circle-outline" />该环节由发包方设定，每完成一个环节，请提交发包方进行确认，以更新项目制作进度。</span>
                <span v-if="UserType == 2 || UserType == 3"><Icon type="ios-information-circle-outline" />您可以为当前项目设置环节，以便跟踪整个项目进度。最终结项，以您发起的【项目完结】为准。</span>
                <div v-if="(UserType == 2 || UserType == 3) && ProjectDetail.ProjectFlow.length == 0" class="set-project-flow-row"><Button @click="handleSetProjectFlow(1)" type="success">设置项目环节</Button></div>
                <Button v-if="(UserType == 2 || UserType == 3) && ProjectDetail.ProjectFlow.length > 0" class="modify-project-btn" @click="handleSetProjectFlow(2)" type="error">修改环节</Button>
                <Timeline v-if="ProjectDetail.ProjectFlow.length > 0" style="margin-left:20px;margin-top:40px;">
                    <TimelineItem v-for="(item,index) in ProjectDetail.ProjectFlow" :key="index">
                        <div slot="dot" class="time-dot-big time-dot" style="">
                            <div>
                            </div>
                       </div>
                        <p class="time" style="margin-left:20px;">{{item.Title}}-{{item.Rate}}%</p>
                        <p style="display:flex;margin-left:20px;margin-bottom:30px;">
                            <span style="width:85%;">{{item.Content}}</span>
                            <Button v-if="item.Status == 0 && UserType == 1" @click="showApproval(item)" type="primary" size="small">环节确认</Button>
                            <Button v-if="item.Status == 2 && UserType != 1" @click="showApproval(item)" type="primary" size="small">环节审核</Button>
                            <img v-if="item.Status == 1" style="position:absolute;right:50px;top:12px;" src="../../assets/dui_icon.png" alt=""></p>
                            <img v-if="item.Status == 2 && UserType == 1" style="position:absolute;right:50px;top:12px;" src="../../assets/wait_icon.png" alt=""></p>
                            <img v-if="item.Status == 0 && UserType != 1" style="position:absolute;right:50px;top:12px;" src="../../assets/wait_icon.png" alt=""></p>
                    </TimelineItem>
                </Timeline>
            </div>
              <div class="box-import-right"> 
                <p><img src="../../assets/p_icon.png" alt="">项目记录</p>
                 <Timeline>
                    <TimelineItem v-for="(item, index) in FlowRecordList" :key="index">
                        <div v-if="item.TypeID == 0" slot="dot"  class="time-dot"><div></div></div>
                        <Icon v-if="item.TypeID == 1" type="md-help-circle"  slot="dot" size="20"  color="#FF7F00" />
                        <Icon v-if="item.TypeID == 2" type="ios-close-circle" slot="dot" size="20"  color="#FA5A5A" />
                        <Icon v-if="item.TypeID == 3" type="md-checkmark-circle" slot="dot" size="20"  color="#2DB200" />
                        <p class="time">
                            {{item.Tip}}
                            <!-- <a v-if="item.TypeID == 3" href="/#/index/CapitalDetail">查看详情</a> -->
                        </p>
                        <p class="content">{{item.AddTime}}</p>
                    </TimelineItem>
                </Timeline>
            </div>

        </div>
        <Link-modal :showExamine="showExamine" @click="sureApproval" @closeWindow="closeWindow"></Link-modal>
        <Modal v-model="showBiddingRecordDetail" :closable="false" width='480'>
            <div slot="header" class="header-modal">
               <img src="../../assets/detail.png" alt="">
               <span>竞价记录详情</span>
               <img class="close" @click="showBiddingRecordDetail=false" src="../../assets/close.png" alt="">
            </div>
            <div class="content-modal table-c">
                <table border="0" cellspacing="0" cellpadding="0">
                          <tr>
                                <td  class="label"  width="100">项目报价</td>
                                <td width="140">{{BiddingRecordDetail.Fee}}元</td>
                                 <td  class="label"  width="100">项目周期</td>
                                <td width="140">{{BiddingRecordDetail.Day}}天</td>
                          </tr>
                          <tr>
                                <td  class="label"  width="100">联系人</td>
                                <td width="140">{{BiddingRecordDetail.Realname}}</td>
                                 <td  class="label"  width="100">手机号</td>
                                <td width="140">{{BiddingRecordDetail.Tel}}</td>
                          </tr>
                          <tr>
                               <td class="label" width="100">邮箱</td>
                                <td width="140">{{BiddingRecordDetail.Email}}</td>
                                <td  class="label"  width="100">提交时间</td>
                                <td width="140">{{BiddingRecordDetail.AddTime}}</td>
                          </tr>
                          <tr>
                               <td class="label" width="100">竞标说明</td>
                               <td width="380" colspan="5">{{BiddingRecordDetail.Content}}</td>
                          </tr>
                    </table>
            </div>
           <div slot="footer">
               <Button type="info" @click="showBiddingRecordDetail=false" >关闭</Button>
           </div>
       </Modal>
       <Modal  v-model="showSetProjectFlow" :closable="false" width='765'>
            <div slot="header" class="header-modal">
               <img src="../../assets/lin_icon.png" alt="">
               <span>环节设置</span>
               <img class="close" @click="showSetProjectFlow=false" src="../../assets/close.png" alt="">
            </div>
            <div class="set-inner-box">
                    <Row :class="index%2==1 ? 'bgc-blue' : ''" v-for="(row,index) in ProjectFlowList" :key="index" style="padding-top:10px;padding-left:15px;padding-bottom:20px;">
                        <Col span="3"><span class="num">{{index+1}}</span></Col>
                        <Col span="18">
                            <div class="input-row">
                                <Input class="flow-name-input" prefix="md-list-box" v-model="row.Title" placeholder="请输入环节名称" />
                                <Input class="flow-percent-input" prefix="md-pie" type="number" v-model="row.Rate" placeholder="百分比" />
                            </div>
                            <div class="input-row">
                                <Input class="flow-desc-textarea" type="textarea" :rows="4" v-model="row.Content" placeholder="请输入环节描述" />
                            </div>
                        </Col>
                        <Col span="3">
                            <Icon class="del-btn" type="md-trash" color="#01aae3" size="30" @click="delProjectFlow(index)" />
                        </Col>
                    </Row>
                    <div class="add-row">
                        <Icon class="add-btn" @click="addProjectFlow" size="50" color="#01aae3" type="ios-add-circle" />
                    </div>
                    <div class="info-row">已建环节：{{ProjectFlowList.length}}  已设占比：{{percentSumNum}}%</div>
               </div>
           <div slot="footer">
               <Button type="info" @click="showSetProjectFlow=false" >取消</Button>
               <Button type="success" @click="handleSubmitFlowList" >确定</Button>
           </div>
       </Modal>
       <Modal v-model="showDelayWindow" :closable="false" width='480'>
            <div slot="header" class="header-modal">
               <img src="../../assets/detail.png" alt="">
               <span>项目延期</span>
               <img class="close" @click="showDelayWindow=false" src="../../assets/close.png" alt="">
            </div>
            <div class="content-modal table-c">
                <Row class="chooseProjectRow" >
                    <Col span="9">延期天数（单位：天）</Col>
                    <Col span="5"><Input v-model="DelayDayNum" placeholder="" type="number" style="width: 150px" /></Col>
                </Row>
            </div>
           <div slot="footer">
               <Button type="info" @click="showDelayWindow=false" >关闭</Button>
               <Button type="success" @click="handleSubmitDelay" >确定</Button>
           </div>
       </Modal>
       <Modal v-model="showCompleteWindow" width="360">
        <p slot="header" style="color:#f60;text-align:center">
            <Icon type="ios-information-circle"></Icon>
            <span>项目完结确认</span>
        </p>
        <div style="text-align:center">
            <p>项目完结后，会将所有款项打给承接方!</p>
            <p>您要将项目完结吗?</p>
        </div>
        <div slot="footer">
            <Button type="success" size="large" long :loading="modalLoading" @click="handleSubmitComplete">确认完结</Button>
        </div>
        </Modal>
        <Modal v-model="showCloseWindow" width="360">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>项目关闭确认</span>
            </p>
            <div style="text-align:center">
                <p>请选择终止方式：</p>
                <RadioGroup v-model="CloseType">
                    <Radio :label="6">有效终止</Radio>
                    <Radio :label="7">无效终止</Radio>
                </RadioGroup>
                <p>有效终止会将冻结款项打给承接方，无效则不打款</p>
                <p>您要将项目关闭吗?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modalLoading" @click="handleSubmitCloseProject">确认关闭</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import LinkModal from "../../components/Link-modal.vue";
export default {
    components:{
        LinkModal
    },
    data(){
        return{
            ID:0,//项目ID
            FlowID:0,//流程ID
            FlowInfo:[],//当前流程信息
            UserType:1,//1:接包方（供应商）2:发包方；
            UserInfo:[],//用户信息
            fileUrl:this.$baseImg,//文件地址
            DelayDayNum: '',//延期天数
            showExamine: false,//显示竞价记录详情
            finshFlag:true,//进度标记
            showProjectDetail:false,//是否显示项目详情
            showBiddingRecordDetail: false,//是否显示竞价记录详情弹框
            showSetProjectFlow: false,//是否显示环节设置弹框
            showDelayWindow: false,//是否显示延迟窗口
            showCompleteWindow: false,//是否显示完结窗口
            showCloseWindow: false,//是否显示关闭项目窗口
            CloseType: 6,//关闭项目方式：6、有效终止，7、无效终止
            modalLoading:false,//窗口等待
            ProjectDetail:{//项目详情
                ProjectMember:{},
                ProjectFlow:[]
            },//项目详情
            BiddingRecordDetail:[],//竞价记录详情
            ProjectFlowList:[],//设置环节列表
            percentSumNum:0,//百分比合计总额
            FlowRecordList:[],//环节记录列表
            columnsBiddingRecordList: [//竞价记录列表格式
                    {
                        title: '提交时间',
                        key: 'AddTime',
                        align:'center'
                    },
                    {
                        title: '竞标人',
                        key: 'Realname',
                         align:'center'
                    },
                     {
                        title: '联系方式',
                        key: 'Tel',
                         align:'center'
                    },
                      {
                        title: '项目周期',
                        key: 'Day',
                         align:'center'
                    },
                      {
                        title: '项目报价',
                        key: 'Fee',
                         align:'center'
                    },
                    {
                        title: '操作',
                        key: 'address',
                        align:'center',
                        render:(h,params)=>{
                             var text="修改";
                             if(params.row.Status==0){
                                 text="竞标";
                             }
                              return h('div',[
                                     h('Button',{
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.catBiddingRecordDetail(params.row);
                                                }
                                            }
                                },'查看详情')
                            ])
                         }
                    }
                ],

        }
    },
    mounted(){
        this.ID=this.$route.query.ID;
        if(this.$getLS('AdminInfo')){
            this.UserInfo = JSON.parse(this.$getLS('AdminInfo'));
            this.UserType = this.UserInfo.Type;
        }
        this.init();
    },
    methods:{
        //初始化数据
        init(){
            let params = {
                ID:this.ID
            }
            this.$post('api/manage.ProjectManage/getProjectDetail', params).then(res=>{
                if (res.code == 1) {
                    let ProjectDetail = res.data;
                    ProjectDetail.Attach = JSON.parse(ProjectDetail.Attach);
                    this.ProjectDetail = ProjectDetail;
                }
            })
            let paramsList = {
                ProjectID: this.ID,
                MemberID: this.UserInfo.ID,
                UserType: this.UserType,
            }
            this.$post('api/manage.ProjectManage/getProjectFlowRecord', paramsList).then(res=>{
                if (res.code == 1) {
                    this.FlowRecordList = res.data;
                }
            })
        },
        //显示接包方和收包方提交审核和环节确认
        showApproval(item){
            this.showExamine=true;
            this.FlowID = item.ID;
            let params = {
                'FlowID' : this.FlowID,
                'ProjectID' :this.ID,
            }
            this.$post('api/manage.ProjectManage/getFlowInfo',params).then(res=>{
                if(res.code==1){
                    let FlowInfo = res.data;
                    for (let i = 0; i < FlowInfo.flowProcess.length; i++) {
                        let AttachList = JSON.parse(FlowInfo.flowProcess[i]['Attach']);
                        for (let j = 0; j < AttachList.length; j++) {
                            AttachList[j]['url'] = this.fileUrl+AttachList[j]['url'];
                        }
                        FlowInfo.flowProcess[i]['Attach'] = AttachList;
                    }
                    this.FlowInfo = FlowInfo;
                    console.log(this.FLowInfo);
                }
            })
        },
        //查看竞价记录详情
        catBiddingRecordDetail(row) {
            this.showBiddingRecordDetail = true;
            this.BiddingRecordDetail = row;
        },
        //确认提交审核和环节确认的接口
        sureApproval(SubmitType,content,File,Fee){
            if((content && content.length > 0) || (File && File.length > 0)){
                let params = {
                    'TypeID':SubmitType,
                    'FlowID':this.FlowID,
                    'Content':content,
                    'Attach':File,
                    'MemberID':this.UserInfo.ID,
                    'Fee':Fee,
                }
                this.$post('api/manage.ProjectManage/addFlowProcess',params).then(res=>{
                    if(res.code==1){
                        this.showExamine=false;
                        this.$Message.success(res.msg);
                        this.init();
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            } else {
                this.$Message.error('环节确认内容或附件不能为空');
            }
        },
        //打开项目详情
        openProjectDetail(){
           this.showProjectDetail=!this.showProjectDetail;
        },
        //设置项目环节
        handleSetProjectFlow(type) {
            this.showSetProjectFlow = true;
            if (type == 1) {
                this.ProjectFlowList = [{//设置环节列表
                    Title:'',
                    Rate:'',
                    Content:'',
                }]
            } else {
                this.ProjectFlowList = [];
                for (let i = 0; i < this.ProjectDetail.ProjectFlow.length; i++) {
                    let flow = {
                        ID : this.ProjectDetail.ProjectFlow[i].ID,
                        Title : this.ProjectDetail.ProjectFlow[i].Title,
                        Rate : this.ProjectDetail.ProjectFlow[i].Rate,
                        Content : this.ProjectDetail.ProjectFlow[i].Content
                    }
                    this.ProjectFlowList.push(flow);
                }
            }
        },
        //添加项目环节
        addProjectFlow() {
            let flow = {
                Title : '',
                Rate : '',
                Content: ''
            }
            this.ProjectFlowList.push(flow);
            this.handlePercentSum();
        },
        //删除项目环节
        delProjectFlow(i) {
            if (this.ProjectFlowList.length <= 1) {
                this.$Message.error('至少设置一个环节');return;
            }
            this.ProjectFlowList.splice(i, 1);
            this.handlePercentSum();
        },
        //设置总百分比
        handlePercentSum() {
            let percentSumNum = 0;
            for (let i = 0; i < this.ProjectFlowList.length; i++) {
                if (this.ProjectFlowList[i].Rate > 0) {
                    percentSumNum += parseInt(this.ProjectFlowList[i].Rate);
                }
            }
            this.percentSumNum = percentSumNum;
        },
        //提交环节设置
        handleSubmitFlowList() {
            this.handlePercentSum();
            if (this.percentSumNum > 100) {
                this.$Message.error('环节总和不能超过100%');return;
            }
            for (let i = 0; i < this.ProjectFlowList.length; i++) {
                if (this.ProjectFlowList[i].Title == '') {
                    this.$Message.error('请填写环节名称');return;
                }
                if (this.ProjectFlowList[i].Rate == '') {
                    this.$Message.error('请填写百分比');return;
                }
                if (this.ProjectFlowList[i].Rate == '') {
                    this.$Message.error('请填写环节描述');return;
                }
            }
            var params={
                ProjectID: this.ID,
                ProjectFlowList: this.ProjectFlowList
            }
            this.$post('api/manage.ProjectManage/setProjectFlow',params).then(res=>{
                if(res.code==1){
                    this.showSetProjectFlow = false;
                    this.$Message.success(res.msg);
                    this.init();
                }else{
                    this.$Message.error(res.msg);
                }
            })
        },
        //处理项目延期
        handleDelay() {
            this.showDelayWindow = true;
        },
        //提交项目延期日期
        handleSubmitDelay() {
            if (this.DelayDayNum == '') {
                this.$Message.error('请填写延期天数');return;
            }
            let params = {
                'ID' : this.ID,
                'DelayDayNum': this.DelayDayNum 
            }
            this.$post('api/manage.ProjectManage/delayProject',params).then(res=>{
                if(res.code==1){
                    this.$Message.success(res.msg);
                    this.showDelayWindow = false;
                    this.init();
                }else{
                    this.$Message.error(res.msg);
                }
            })
        },
        //提交项目完结
        handleSubmitComplete() {
            this.modalLoading = true;
            let params = {
                'ID' : this.ID,
            }
            this.$post('api/manage.ProjectManage/completeProject',params).then(res=>{
                if(res.code==1){
                    this.modalLoading = false;
                    this.showCompleteWindow = false;
                    this.$Message.success(res.msg);
                    // this.$router.push({path:'BiddingProject'});
                    this.init();
                }else{
                    this.$Message.error(res.msg);
                }
            })
        },
        //提交项目关闭
        handleSubmitCloseProject() {
            this.modalLoading = true;
            let params = {
                'ID' : this.ID,
                'Status' : this.CloseType,
            }
            this.$post('api/manage.ProjectManage/closeProject',params).then(res=>{
                if(res.code==1){
                    this.modalLoading = false;
                    this.showCloseWindow = false;
                    this.$Message.success(res.msg);
                    this.init();
                }else{
                    this.$Message.error(res.msg);
                }
            })
        },
        //关闭窗口
        closeWindow() {
            this.showExamine = false;
        }
    }
    
}
</script>
<style lang="less" scoped >
.box{
    padding:30px;
    box-sizing: border-box;
            background-color: #F0F3F6;
            .box-step{
                background-color: #fff;
                margin-top: 20px;
                padding:20px;
            }
    .box-contaner{
        background-color: #fff;
        margin-top: 20px;
        box-shadow: 3px 4px 5px #eee;
        .box-top{
            padding:20px;
            background-color: #F7FAFC;
            padding-bottom:0px;
            margin-bottom: 20px;
            .box-top-title{
                margin-bottom: 20px;
            }
                 .box-top-center{
            font-size: 14px;
            color:#9DA6AC;
            margin-bottom: 20px;
            text-align: center;
            .ivu-col-span-3{
                text-align: center;
            }
            span{
                color: #334659;
            }
        }
        .box-top-bottom{
            border-top:1px solid #E6E9EB;
            border-bottom:1px solid #E6E9EB;
            padding: 10px 0px;
            .ivu-col{
                display: flex;
                span{
                    color: #8795A4;
                    font-size: 14px;
                    margin-left: 10px;
                }
            }
        }
            .title{
                        font-size: 20px;
                        button{
                            margin-left: 10px;
                        }
                    }
        .ivu-col-span-4{
             text-align: right;
             display: block!important;
             span{
                 float: right;
                 color: #334659!important;
             }

        }
        }
        .box-center{
            padding:20px;
            h2{
                display: flex;
                font-size: 22px;
                font-weight: normal;
                margin-bottom:20px;
                img{
                    margin-right:10px;
                }
            }
            >p{
                font-size: 16px;
                line-height: 30px;
            }
            >ul{
                overflow: hidden;
                li{
                    float: left;
                    margin-right: 10px;
                }
            }
        }
   
     .btn-tips{
         text-align: center;
         font-size: 15px;
         padding-bottom: 10px;
         cursor: pointer;
     }
       
    }
    }
    .line-dot{
        display: flex;
        padding:0px 4%;
        .dot{
            width: 13px;height: 13px;
            background-color:#DDDDDD;
            border-radius: 50%;
        }
      
        .line{
            width: 50%;
            height: 2px;
            background-color: #ddd;
            margin-top: 11/2px;
        }
          .active-dot{
              background-color:#01AAE3;
        }
         .active-line{
              background-color:#00B200;
        }
        .process-num{
                width:50%;margin-top:-4px;position:relative;
                >span{
                position:absolute;top:-10px;left:40%;
                width: 30px;
                height: 16px;
                color: #fff;
                background-color: #00B200;
                font-size: 12px;
                text-align: center;
                border-radius: 2px;
                margin-left: -15px;
                      &:after{
                    border: 6px solid transparent;
                    border-top:6px solid #00B200;
                    width: 0;
                    height: 0;
                    position: absolute;
                    top:16px;
                    left:8px;
                    content: ' '
                }
                }
          
        }
    }
    .line-text{
        text-align: center;
        color: #334659;
        margin-top: 20px;
        p{
            color: #8795A4;
        }
    }
    .box-import{
        overflow: hidden;
        margin-top: 20px;
        >div{
            width: 49%;
            float: left;
            height: 100%;
            background-color: #fff;
            box-shadow: 3px 4px 5px #eee;
            padding:20px;
            box-sizing: border-box;
            >p{
                color: #33475B;
                display: flex;
                font-size: 22px;
                margin-bottom: 20px;
                img{
                    margin-right:10px;
                    width: 29px;
                    height: 29px;
                }
            }
        }
        .box-import-left{
            position: relative;
            margin-right:2%;
            >span{
                display: block;
                padding: 5px 10px;
                background-color: #E3EEF4;
                color:#637283;
                margin-bottom: 20px;
                i{
                    font-size: 16px;
                    margin-right: 10px;
                }
            }
            .set-project-flow-row {
                text-align:center;
            }
            .modify-project-btn {
                position: absolute;
                right: 20px;
                top: 20px;
            }
        }
        
    }
    .time-dot{
            margin-left:10px;overflow:hidden;width:20px;height:20px;background-color:#E7F4FD;border-radius:50%;
            >div{
                width:11px;height:11px;border-radius:50%;margin-left:4.5px;margin-top:4.5px;background-color:#C0C9D8;
            }
    }
    .time-dot-big{
        margin-left:-5px;width:50px;height:50px;
        >div{
            width:26px;height:26px;
            margin-left:12px;margin-top:12px;
        }
    }
    .table-c{
        table{
            border-right:1px solid #CAF2FF;border-bottom:1px solid #CAF2FF;
            td{
                border-left:1px solid #CAF2FF;
                padding:10px;
                text-align: center;
                border-top:1px solid #CAF2FF;
                font-size:12px;
            }
            .label{
                background-color: #F0FCFF;
                color: #0092C1;
            }
        } 
    }
    .header-modal{
        padding:10px 15px;
        color: #fff;
        background-color: #01AAE3;
        font-size: 22px;
        display: flex;
        position: relative;
        span{
            margin-left: 20px;
            margin-top: 3px;
        }
        .close{
            width: 22px;
            height: 22px;
            position: absolute;
            right:14px;
            cursor: pointer;
            top:14px;
        }
    }
    .set-inner-box {
        padding: 20px 0;
        .num {
            margin: 30px 20px;
            display:flex;
            justify-content: center;
            font-size:56px;
            color:#01aae3;
            font-style: italic;
            border-bottom: 1px solid #01aae3;
        }
        .input-row {
            margin-top: 10px;
            margin-left:20px;
            .flow-name-input {
                width: 400px;
            }
            .flow-percent-input {
                width: 100px;
                margin-left: 5px;
            }
            .flow-desc-textarea {
                width: 510px;
            }
        }
        .del-btn {
            cursor: pointer;
            margin-top: 60px;
            margin-left: 20px;
        }
        .add-row {
            margin-top: 30px;
            text-align: center;
            .add-btn{
                cursor: pointer;
                width: 50px;
                height: 50px;
            }
        }
        .info-row {
            margin-top: 20px;
            text-align: center;
            color: #01aae3;
        }
    }
    .bgc-blue {
        background-color: #eafcff;
    }
    .chooseProjectRow {
        margin-top:30px;
        margin-left:18%;
        margin-bottom:30px;
    }
    .ivu-modal-header {
        border-bottom: 1px solid #e8eaec;
        padding: 14px 16px;
        line-height: 1;
    }
    .ivu-modal-body {
        padding: 16px;
        font-size: 14px;
        line-height: 1.5;
}
</style>


// WEBPACK FOOTER //
// src/view/Project/ProjectDetailBidding.vue